<template>
  <div class="help padding_top">
    <p><strong>第一步：</strong>登录状态下，点击右上角头像，在下拉菜单中点击<span class="orange">【个人主页】</span>，即可进入【医生工作室】，在顶部菜单栏中点击<span
        class="orange">【预约管理】</span>
    </p>
    <img src="../../../assets/img/docAppointRes_a.png" alt="">
    <p><strong>第二步：</strong>在【预约管理】页面中，点击<span class="orange">【预约设置】</span>按钮，进入【预约设置】页面
    </p>
    <img src="../../../assets/doctorImg/appointSet_b.png" alt="" height="321">
    <p><strong>第三步：</strong>在【预约设置】页面左侧的【咨询设置】，按照提示依次选择【咨询方式】，填写【初次咨询价格】【再次咨询价格】【一次咨询时长】，选择【工作时区】，点击<span
        class="orange">【保存设置】</span>，保存咨询设置
    </p>
    <img src="../../../assets/doctorImg/appointSet_c.png" alt="" height="479">
    <p><strong>第四步：</strong>在【预约设置】页面右侧的【时间设置】，进行【特殊设置】和【周设置】，建议先进行【周设置】</p>
    <img src="../../../assets/doctorImg/appointSet_d.png" alt="" height="406">
    <p><strong>第五步：</strong>
      【周设置注解】<br/>
      以周为单位,选择开放的时间段，选中表示固定每周开放的具体时间<br/>
      注意:此设置会被【特殊设置】覆盖
    </p>
    <p><strong>【步骤】</strong><br/>
      点击【周设置】按钮，弹出【周设置】弹窗，在弹窗中选择每天开放的时间，选中方格变成深蓝色，点击【周*】上的□，则全天都被选择，点击【保存设置】按钮，之后每周的时间开放同步更新
    </p>
    <img src="../../../assets/doctorImg/appointSet_e.png" alt="" height="892">
    <p><strong>第五步：</strong>
      【特殊设置注解】
      指定某一天开放或关闭的时，此设置会覆盖周设置<br/>
      日历中，蓝色标点代表周设置时间，红色标点代表特殊设置时间
    </p>
    <p><strong>【步骤】</strong><br/>
      在日历中选中某一天，在右侧时间表中，选中开放预约时间（可不选，可连选），点击<span class="orange">【保存设置】</span>按钮，可保存特殊时间设置
    </p>
    <img src="../../../assets/doctorImg/appointSet_f.png" alt="" height="663">
  </div>

</template>

<script>
export default {
  name: "appointSet",
  data() {
    return {}
  },
  mounted() {
  },
  methods: {},
}
</script>

<style lang="scss" scoped>
@import "../../../assets/css/help";

</style>
